var filters = (function() {

    var filterBar = null;
    var filterModal = null;
    var quickFilters = window.quickFilters || ['Brand', 'EFS', 'Winter Approved', 'Bolt Pattern', 'Diameter', 'OE Hub']; 
    var sortFiltersArray = ['Brand', 'Diameter', 'Width', 'Aspect Ratio', 'Speed Rating', 'Finish', 'Offset', 'Centerbore', 'Bolt Pattern', 'Winter Approved', 'EFS']
    var blockedFilters = ['Bolt Pattern'];
    var cachedVehicleCheck = JSON.parse(localStorage.getItem('cached-vehicle')) ? JSON.parse(localStorage.getItem('cached-vehicle')).ConfigurationID : null;

    var currentUrl = parseCurrentUrl();

    var viewModel = window.viewModel = {
        active: true,
        currentSearch: '',
        vehicle: {
            selected: false,
            description: null
        },
        quickSpecFilters: {},
        innerWidth: window.innerWidth,
        hasQuickSpecFilters: false,
        specFilters: {},
        specFiltersActive: 0,
        specDimensionsActive: 0,
        resetVehicleCache: resetVehicleCache,
        sliderChecked: false,
        toggleSliderFilters: toggleSliderFilters
    };

    var currentPage = (function (pathMatch){
        return pathMatch && pathMatch[0] || undefined;
    })(location.pathname.match(/[^\/]+$/));

    initialize();

    return {
        lastSelectedFilters: getLastSelectedFilters,
        currentPageToken: currentPage
    };

    function initialize() {

        initializeTireSizeQuickFilter();
        initializeSearch();
        
        $(document.body)
            .on('vehicle-activated', function(e) {
                viewModel.vehicle.selected = (e.VehicleDescription !== null);
                viewModel.vehicle.description = e.VehicleDescription;
                viewModel.vehicle.fitmentProfile = e.FitmentProfile;

                if (viewModel.vehicle.selected) {
                    refreshBlockedFilters();
                }
            })
            .on('wheel-activated', function (e) {
                // Only show the wheel filter on the tire products results page
                if (currentPage !== 'tires') return;

                var wheelDescription = e.WheelDescription;

                if (!e.WheelDescription) return;

                var diameterMin = wheelDescription.DiameterMin;
                var diameterMax = wheelDescription.DiameterMax;
                var widthMin = wheelDescription.WidthMin;
                var widthMax = wheelDescription.WidthMax;

                var valueString;

                if (diameterMin == diameterMax && widthMin == widthMax) {
                    valueString = diameterMin + 'x' + widthMin + ' Wheels';
                } else {
                    valueString = diameterMin + 'x' + widthMin + ' to ' + diameterMax + 'x' + widthMax + ' Wheels';
                }

                var fitsFilter = [
                    {
                        Active: true,
                        EditorType: 1,
                        FilterType: undefined,
                        Name: 'Fits',
                        Value: valueString
                    }
                ];

                fitsFilter.ClearAction =  function (clearingAllFilters) {
                    $(document.body).addClass('loading');

                    var d = $.Deferred();
                    wheels.clear(function () {
                        d.resolve();

                        if (!clearingAllFilters) {
                            location.reload();
                        }
                    });

                    return d;
                }

                loadFilterCollection({
                    Fits: fitsFilter
                });
            });

        // Merge in our filter data that has been injected onto the page.
        if (window.rsfilters) {
            for(var i = 0; i < window.rsfilters.length; i++) {
                var group = window.rsfilters[i];
                if (group.SpecFiltersEnabled === false) continue;

                loadFilterCollection(sortFilters(group.SpecFilters));
            }
        }

        // Setup our Vue components for handling filters
        filterBar = new Vue({
            el: document.getElementById('product-filters'),
            data: viewModel,
            methods: {
                applyFilters: applyCurrentFilterSelections,
                updateOversize: updateOversizeValue,
                removeFilter: removeFilter,
                clearFilters: function() {
                    var promises = [];
                    var paramsToClear = [];

                    for (name in viewModel.specFilters) {
                        var f = viewModel.specFilters[name];

                        if ($.isFunction(f.ClearAction)) {
                            var result = f.ClearAction(true);

                            if (result && $.isFunction(result.done)) {
                                promises.push(result);
                            }
                        }

                        if (f.UrlParams) paramsToClear = paramsToClear.concat(f.UrlParams);
                    }
                    $.when.apply($, promises).done(function () {
                        updateUrlWithSpecs([], [], [], paramsToClear); 
                    });
                },
                generateActiveFilterString: function(coll) {
                    if (coll.EditorType === 10 && this.sliderChecked) {
                        var min = null;
                        var max = null;

                        for(var i = 0; i < coll.length; i++) {
                            var f = coll[i];
                            if (f.Active === false) continue;                           

                            min = min === null ? f.Value : Math.min(f.Value, min);
                            max = max === null ? f.Value : Math.max(f.Value, max);
                        }

                        if (min === max) return min;
                        return min + ' to ' + max;
                    } else if (coll.EditorType === 100) {
                        
                        var output = null;
                        for(var i = 0; i < coll.length; i++) {
                            if (coll[i].Active) {
                                output = coll[i].Value;
                                break;
                            }
                        }

                        if (coll.vm.selected.length > 1) {
                            output += ' and ' + (coll.vm.selected.length - 1) + ' more';
                        }

                        return output;

                    } else if (coll.vm.selected.length > 0) {
                        var output = null;
                        for(var i = 0; i < coll.length; i++) {
                            if (coll[i].Active) {
                                output = coll[i].Value;
                                break;
                            }
                        }

                        if (coll.vm.selected.length > 1) {
                            output += ' and ' + (coll.vm.selected.length - 1) + ' more';
                        }

                        return output;
                    } else {
                        return 'N/A';
                    }
                },
                search: function () {
                    var url = parseCurrentUrl();
                    var search = this.currentSearch;

                    if (location.pathname.substr(-5).toLowerCase() === 'tires') {
                        var matchNumericTireSizes = /\b([1-3][0-9]{2})([0-9]{2})([1-3][0-9])\b/g;
                        search = search.replace(matchNumericTireSizes, "$1/$2R$3");
                    }

                    if (search) url.params.search = search;
                    else delete url.params.search;

                    updateCurrentUrl(url);
                }
            },
            computed: {
                showVehiclePanel: function() {
                    return ((this.innerWidth < 768 && this.vehicle.selected) || this.innerWidth > 767);
                }
            },
            created: function () {
                var self = this;
                window.addEventListener('resize', function() {
                    self.innerWidth = window.innerWidth;
                })
            },
            mounted : function() {
                $(this.$el).removeClass('loading');
            }
        });

        filterModal = new Vue({
            el: document.getElementById('product-filter-modal'),
            data: viewModel,
            methods: {
                applyFilters: applyCurrentFilterSelections,
                updateOversize: updateOversizeValue,
            }
        });

        function dispatchNativeEvent(el, type) {
            var event;
            
            if(typeof(Event) === 'function') {
                event = new Event(type);
            }else{
                event = document.createEvent('Event');
                event.initEvent(type, false, false);
            }

            el.dispatchEvent(event);
        }

        $('#product-filters').on('show.bs.dropdown', '.dropdown', function () {
            dispatchNativeEvent(this, 'show');
        });
    }

    function sortFilters(collection) {
        var sortArray = [];
        var sortedCollection = Object.keys(collection).sort(function(a, b){
            var indexA = sortFiltersArray.indexOf(a),
                indexB = sortFiltersArray.indexOf(b);

            if (indexA < 0) indexA = Infinity;
            if (indexB < 0) indexB = Infinity;

            if(indexA < indexB) return -1;
            if(indexA > indexB) return 1;
            return 0;
        });
        for (var filter in sortedCollection) {
            sortArray[sortedCollection[filter]] = collection[sortedCollection[filter]];
        }
        return sortArray;
    }

    function removeFilter(name) {
        var f = viewModel.specFilters[name];
        f.vm.selected.length = 0;
        f.vm.selectedMin = f.vm.min;
        f.vm.selectedMax = f.vm.max;
        f.vm.selectedValue = '';

        for(var i = 0; i < f.length; i++) {
            f[i].Active = false;
        }
        
        var hasClearAction = typeof f.ClearAction === 'function';

        if (hasClearAction) {
            var result = f.ClearAction(false);

            if (result && $.isFunction(result.done)) {
                result.done(function () {
                    refreshActiveCount(false);
                    forceViewUpdate();
                })
            } else {
                refreshActiveCount(false);
                forceViewUpdate();    
            }
        } else {
            refreshActiveCount(true);
            forceViewUpdate();
        }
    }

    function toggleSliderFilters() {
        this.sliderChecked = this.sliderChecked == true ? false : true;
    }

    function refreshBlockedFilters() {
        if (viewModel.vehicle.selected) {
            var validQfCount = 0;

            for(var f in viewModel.quickSpecFilters) {
                if (blockedFilters.indexOf(f) != -1) {
                    delete viewModel.quickSpecFilters[f];
                } else {
                    validQfCount++;
                }
            }

            for(var f in viewModel.specFilters) {
                if (blockedFilters.indexOf(f) != -1) {
                    delete viewModel.specFilters[f];
                }
            }

            viewModel.hasQuickSpecFilters = (validQfCount > 0);
            forceViewUpdate();
        }
    }

    function forceViewUpdate()
    {
        viewModel.renderComponent  = false;
        filterBar.$nextTick(function() {
            viewModel.renderComponent  = true;
        });
    }

    function loadFilterCollection(coll) {
        for(var attr in coll) {
            var all = viewModel.specFilters[attr];
            if (!all) {
                all = viewModel.specFilters[attr] = [];
                all.vm = {
                    active: true,
                    range: [ null, null ],
                    rangeSelected: [ null, null ],
                    selected: [],
                    oversize:false
                };
            }

            if (quickFilters.indexOf(attr) != -1) {
                viewModel.hasQuickSpecFilters = true;
                viewModel.quickSpecFilters[attr] = viewModel.specFilters[attr]
            }

            var list = coll[attr];

            for(var i = 0; i < list.length; i++) {
                var f = list[i];

                all.push(f);
                all.EditorType = (typeof all.EditorType === 'undefined') ? f.EditorType : Math.min(all.EditorType, f.EditorType);
                all.FilterType = f.FilterType;
                
                if( all.EditorType == 100 && f.Active ) {
                    console.log( all );
                    all.vm.oversize = true;
                }

                if (f.UrlParams) all.UrlParams = (all.UrlParams || []).concat(f.UrlParams);
            }

            if (list.ClearAction) all.ClearAction = list.ClearAction;

            if (all.EditorType == 10){
                all.sort(function(x, y) {
                    return x.Value - y.Value;
                });
            }
        }
        refreshActiveCount();
    }

    function refreshActiveCount(updateUrl) {
        var activeDimensions = 0;
        var activeSpecIds = [];
        var activeCombinationFilterIds = [];
        var activeCustomFilterIds = [];

        var selectedFilters = {
            
        };

        for(var attr in viewModel.specFilters) {
            var all = viewModel.specFilters[attr];
            all.vm.selected.length = 0;

            for(var i = 0; i < all.length; i++) {
                var f = all[i];

                var value = f.Value;
                if (isNaN(value) == false) value = parseFloat(value);

                // Fine - It will be NaN on non-numeric ranges
                all.vm.range[0] = all.vm.range[0] === null ? value : Math.min(all.vm.range[0], value);
                all.vm.range[1] = all.vm.range[1] === null ? value : Math.max(all.vm.range[1], value);

                if (f.Active) {
                    if (f.FilterType == 0) { // Specs Filter
                        activeSpecIds.push(f.ID);
                    } else if (f.FilterType == 1) { // Combination Filter
                        activeCombinationFilterIds.push(f.ID);
                    } else if (f.FilterType == 2) { // Custom Filter
                        activeCustomFilterIds.push(f.ID);
                    }

                    if (f.Name in selectedFilters === false) selectedFilters[f.Name] = [];

                    selectedFilters[f.Name].push(f.Value);

                    all.vm.selected.push(f.ID);
                    all.vm.rangeSelected[0] = all.vm.rangeSelected[0] === null ? value : Math.min(all.vm.rangeSelected[0], value);
                    all.vm.rangeSelected[1] = all.vm.rangeSelected[1] === null ? value : Math.max(all.vm.rangeSelected[1], value);
                    all.vm.selectedValue = f.ID;
                }
            }

            if (all.vm.selected.length > 0) activeDimensions++;

            all.vm.rangeSelected[0] = (all.vm.rangeSelected[0] !== null) ? all.vm.rangeSelected[0] : all.vm.range[0];
            all.vm.rangeSelected[1] = (all.vm.rangeSelected[1] !== null) ? all.vm.rangeSelected[1] : all.vm.range[1];
        }

        viewModel.specFiltersActive = activeSpecIds.length + activeCombinationFilterIds.length + activeCustomFilterIds.length;
        viewModel.specDimensionsActive = activeDimensions;

        if (updateUrl) {
            updateUrlWithSpecs(activeSpecIds, activeCombinationFilterIds, activeCustomFilterIds);
        }

        setLastSelectedFilters(currentPage, selectedFilters);

        return activeSpecIds;
    }

    function getLastSelectedFilters(page) {
        var lastSelectedFilters = localStorage.lastSelectedFilters;

        try {
            lastSelectedFilters = JSON.parse(lastSelectedFilters);
        } catch (e) {
            return undefined;
        }

        if (page) return lastSelectedFilters[page];

        return lastSelectedFilters;
    }

    function setLastSelectedFilters(page, selectedFilters) {
        var lastSelectedFilters = getLastSelectedFilters() || {};

        lastSelectedFilters[page] = selectedFilters;

        localStorage.lastSelectedFilters = JSON.stringify(lastSelectedFilters);
    }

    function updateUrlWithSpecs(activeSpecIds, activeCombinationFilterIds, activeCustomFilterIds, parametersToRemove) {
        var urlData = parseCurrentUrl();
        urlData.params.specs = activeSpecIds.join(',');
        urlData.params.filters = activeCombinationFilterIds.join(',');
        urlData.params.cfilters = activeCustomFilterIds.join(',');

        if (parametersToRemove) {
            for (var i = 0; i < parametersToRemove.length; i++) {
                var key = parametersToRemove[i];

                delete urlData.params[key];
            }
        }

        updateCurrentUrl(urlData)
    }
    function updateOversizeValue(collection, el) {
        console.log(collection, el);
        if(  collection.vm.selectedValue )
        {
            collection.vm.selectedValue = undefined;
            applyCurrentFilterSelections();
        }
        else {

            forceViewUpdate();
            this.$forceUpdate();
            $("#" + el).addClass("show");
            $("#" + el).parent().addClass("show");
        }
    }
    function applyCurrentFilterSelections() {
        var activeSpecs = [];
        var activeProductCombinationFilters = [];
        var activeCustomFilters = [];
        var parametersToRemove = [];

        for(var name in viewModel.specFilters) {
            var collection = viewModel.specFilters[name];
            var filterIds = getCurrentFilterSelectionsFromCollection(collection);
            
            if (collection.vm.active && !filterIds.length) {
                if (collection.UrlParams) parametersToRemove = parametersToRemove.concat(collection.UrlParams);
            }

            if (collection.FilterType === 0) { // Spec Filter
                activeSpecs = activeSpecs.concat(filterIds);
            } else if (collection.FilterType === 1 || collection.FilterType === 100) { // Product Combination Filter
                activeProductCombinationFilters = activeProductCombinationFilters.concat(filterIds);
            } else if (collection.FilterType === 2) { // Custom Filter
                activeCustomFilters = activeCustomFilters.concat(filterIds);
                
            }
        }
        //console.log( activeSpecs, activeProductCombinationFilters, activeCustomFilters, parametersToRemove )
        updateUrlWithSpecs(activeSpecs, activeProductCombinationFilters, activeCustomFilters, parametersToRemove);
    }

    function getCurrentFilterSelectionsFromCollection(coll) {
        if ( coll.EditorType === 10 && this.sliderChecked ) {
            var min = coll.vm.rangeSelected[0];
            var max = coll.vm.rangeSelected[1];

            var valuesInRange = [];
            for(var i = 0; i < coll.length; i++) {
                var value = parseFloat(coll[i].Value);
                if (value >= min && value <= max) valuesInRange.push(coll[i].ID);
            }
            if (valuesInRange.length == coll.length) return [];
            else return valuesInRange;
        } else if( coll.EditorType === 100 ) {
            if( coll.vm.selectedValue )
            return coll.vm.selectedValue;
            return [];
        } else {
            return coll.vm.selected;
        }
    }

    function parseCurrentUrl() {
        var searchTokens = window.location.search.split(/[&\?]/);
        var urlParams = {};
        for(var i = 0; i < searchTokens.length; i++) {
            if (searchTokens[i]) {
                var paramTokens = searchTokens[i].split('=');
                urlParams[paramTokens[0]] = decodeURIComponent(paramTokens[1]);
            }
        }
        return {
            baseUrl: window.location.origin + window.location.pathname,
            params: urlParams
        };
    }

    function updateCurrentUrl(urlData) {
        // "url2" is used to properly handle the page number.
        // Removing "url2" breaks the page # reset when changing certain filters.
        // Potentially a better way of doing this.
        // Url gets updated (reloaded) twice when toggling availability filter on a page > 1.
        var url = ''; var url2 = '';
        for(var p in urlData.params) {
            var value = urlData.params[p];
            if (value === '' || value === null) continue;
            if (url.length > 0) {
                url += '&';
            }
            if (url2.length > 0) {
                url2 += '&';
            }

            //We encode these as nop 4.5 encodes on catalog pages (public.catalogproducts.js).
            //Previously these were not encoded, which was resulting in the URL comparison failing below.
            //This would cause the page to get reloaded/redirected multiple times when containing encoded characters.
            url2 += p + '=' + encodeURIComponent(urlData.params[p]);

            if (p.toLowerCase() == 'pagenumber') continue;
            url += p + '=' + encodeURIComponent(urlData.params[p]);
            
            
        }
   
        if (url.length > 0)
            url = urlData.baseUrl + '?' + url;
        else
            url = urlData.baseUrl;

        if (url2.length > 0)
            url2 = urlData.baseUrl + '?' + url2;
        else
            url2 = urlData.baseUrl;

        if(window.location.href != url && window.location.href != url2 )
            window.location.href = url;
    }

    function resetVehicleCache() {
        localStorage.setItem('cached-vehicle', JSON.stringify({
            ConfigurationID: null,
            selectedScheme: null,
            tireOption: null,
            description: null,
            model: null,
            selected: false,
            ready: true
        }))
    }

    function initializeSearch() {
        var urlSearch;

        if ('search' in currentUrl.params) {
            urlSearch = currentUrl.params.search;
        }

        urlSearch = urlSearch || '';
        viewModel.currentSearch = urlSearch;

        if (urlSearch) {
            var searchFilter = [
                {
                    ID: 0,
                    Active: true,
                    EditorType: 1,
                    FilterType: undefined,
                    Name: 'Search',
                    LocalizedName: 'Search',
                    Value: urlSearch,
                    LocalizedValue: urlSearch,
                    UrlParams: ['search']
                }
            ];

            searchFilter.ClearAction =  function (clearingAllFilters) {
                if (clearingAllFilters) return;

                delete currentUrl.params.search;

                updateCurrentUrl(currentUrl);

                return $.Deferred();
            };

            searchFilter.vm = {
                active: true,
                range: [ null, null ],
                rangeSelected: [ null, null ],
                selected: [0]
            };

            loadFilterCollection({
                Search: searchFilter
            });
        }
    }

    function initializeTireSizeQuickFilter() {
        /**
         * A list of all tire sizes retrieved from RS
         * @type {{[width: string]:{[ratio:string]:string[]}}}
         */
        var sizeLookup = undefined;
        var url = currentUrl;
        var urlDiameter, urlWidth, urlRatio, urlSize;

        if ('size' in url.params) {
            urlSize = url.params.size;

            var sizeMatch = urlSize.match(/^([0-9.]+)[/]([0-9]+)[-r]([0-9]+)$/i);

            if (sizeMatch) {
                urlWidth = sizeMatch[1];
                urlRatio = sizeMatch[2];
                urlDiameter = sizeMatch[3];
            }
        }

        if (urlSize) {
            var sizeFilter = [
                {
                    ID: 0,
                    Active: true,
                    EditorType: 1,
                    FilterType: undefined,
                    Name: 'Size',
                    LocalizedName: 'Size',
                    Value: urlSize,
                    LocalizedValue: urlSize,
                    UrlParams: ['size']
                }
            ];

            sizeFilter.ClearAction =  function (clearingAllFilters) {
                if (clearingAllFilters) return;

                var url = parseCurrentUrl();

                delete url.params.size;

                updateCurrentUrl(url);

                return $.Deferred();
            };

            sizeFilter.vm = {
                active: true,
                range: [ null, null ],
                rangeSelected: [ null, null ],
                selected: [0]
            };

            loadFilterCollection({
                Size: sizeFilter
            });
        }
    }
})();